import React from 'react';
import { ClientModel, clientModelInitial } from '../../Models/ClientModel';
import { ClientClipperModel } from '../../Models/ClientClipperModel';
import { ContentModel } from '../../Models/ContentModel';
import { ExtraParameterModel } from '../../Models/ExtraParameterModel';
import { KeywordModel } from '../../Models/KeywordModel';
import { OrganogramModel } from '../../Models/OrganogramModel';
import { SourceModel } from '../../Models/SourceModel';
import { VehicleModel } from '../../Models/VehicleModel';
import { CutoutModel } from '../../Models/CutoutModel';
import { ClientPageTabs } from './enums/ClientPageTabs';
import { ClientIdmConversionRateModel, ClientIrsConversionRateModel } from '../../Models/SocialMediaRateModel';
import { ClientProductModel } from '../../Models/ClientProductModel';

export interface IClientContextProps {
    client: ClientModel,
    setClient: (client: ClientModel) => void,    
    keywords: KeywordModel[],
    setKeywords: (keywords: KeywordModel[]) => void,
    contents: ContentModel[],
    setContents: (contents: ContentModel[]) => void,
    vehicles: VehicleModel[],
    setVehicles: (vehicles: VehicleModel[]) => void,
    sources: SourceModel[],
    setSources: (sources: SourceModel[]) => void,
    extraParameters: ExtraParameterModel[],
    setExtraParameters: (extraParameters: ExtraParameterModel[]) => void,
    clientList: ClientModel[],
    setClientList: (clients: ClientModel[]) => void,
    flatOrganogram: OrganogramModel[],
    setFlatOrganogram: (organogram: OrganogramModel[]) => void,
    organogramId: number,
    setOrganogramId: (value: number) => void,
    clientClippers: ClientClipperModel[],
    setClientClippers: (clientClippers: ClientClipperModel[]) => void,
    cutouts: CutoutModel[],
    setCutouts: (cutout: CutoutModel[]) => void,
    cutoutOrganogram: OrganogramModel[],
    setCutoutOrganogram: (dictionary: OrganogramModel[]) => void,
    clientPage: ClientPageTabs,
    setClientPage: (page: ClientPageTabs) => void,
    editMode: boolean,
    setEditMode: (editMode: boolean) => void,
    clientAvatarFile: File | null,
    setClientAvatarFile: (file: File | null) => void,
    primaryColor: string | null,
    setPrimaryColor: (color: string | null) => void,
    secondaryColor: string | null,
    setSecondaryColor: (color: string | null) => void,
    stockSymbol: string,
    setStockSymbol: (symbol: string) => void,
    idmConversionRateList: ClientIdmConversionRateModel[],
    setIdmConversionRateList: (rate: ClientIdmConversionRateModel[]) => void,
    irsConversionRateList: ClientIrsConversionRateModel[],
    setIrsConversionRateList: (rate: ClientIrsConversionRateModel[]) => void,
    products: ClientProductModel[],
    setProducts: (product: ClientProductModel[]) => void
}

export const ClientContextInitial: IClientContextProps = {
    client: clientModelInitial,
    setClient: () => { ''; },
    keywords: [],
    setKeywords: () => { ''; },
    contents: [],
    setContents: () => { ''; },
    vehicles: [],
    setVehicles: () => { ''; },
    sources: [],
    setSources: () => { ''; },
    extraParameters: [],
    setExtraParameters: () => { ''; },
    clientList: [],
    setClientList: () => { ''; },
    flatOrganogram: [],
    setFlatOrganogram: () => { ''; },
    organogramId: 0,
    setOrganogramId: () => { ''; },
    clientClippers: [],
    setClientClippers: () => { ''; },
    cutouts: [],
    setCutouts: () => { ''; },
    cutoutOrganogram: [],
    setCutoutOrganogram: () => { ''; },
    clientPage: ClientPageTabs.DEFAULT,
    setClientPage: () => { ''; },  
    editMode: false,
    setEditMode: () => { ''; },
    clientAvatarFile: null,
    setClientAvatarFile: () => { ''; },
    primaryColor: null,
    setPrimaryColor: () => { ''; },
    secondaryColor: null,
    setSecondaryColor: () => { ''; },
    stockSymbol: '',
    setStockSymbol: () => { ''; },
    idmConversionRateList: [],
    setIdmConversionRateList: () => { ''; },
    irsConversionRateList: [],
    setIrsConversionRateList: () => { ''; },
    products: [],
    setProducts: () => { ''; }
};

export const ClientContext = React.createContext(ClientContextInitial);